/**
 * Colour photo switching for the product gallery (replaces the Rubik Variant Images app).
 * When the shopper picks a value of the colour option, only slides whose data-colour matches stay
 * visible (slides without data-colour always show). Scrolls back to the first photo and fires
 * `gallery:change` on the gallery so s-gallery-dots rebuilds.
 */
function applyColour(gallery, colour) {
  if (!colour) return;
  const tagged = [...gallery.children].filter((slide) => slide.hasAttribute('data-colour'));
  // Never leave the gallery empty: a colour with no photos of its own shows every photo instead.
  const hasMatch = tagged.some((slide) => slide.getAttribute('data-colour') === colour);
  let changed = false;
  for (const slide of tagged) {
    const hide = hasMatch && slide.getAttribute('data-colour') !== colour;
    if (slide.hidden !== hide) {
      slide.hidden = hide;
      changed = true;
    }
  }
  if (!changed) return;
  gallery.scrollTo({ left: 0 });
  gallery.dispatchEvent(new CustomEvent('gallery:change'));
}

// Re-check the colour selected on load so a colour with no photos of its own never starts on an empty gallery.
document.querySelectorAll('[data-product-gallery][data-colour-option]').forEach((gallery) => {
  const name = gallery.dataset.colourOption;
  const field = [...document.querySelectorAll('input[type="radio"]:checked, select')].find((el) => el.name === name);
  if (field) applyColour(gallery, field.value);
});

document.addEventListener('change', (event) => {
  const field = event.target;
  if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement)) return;
  document.querySelectorAll('[data-product-gallery][data-colour-option]').forEach((gallery) => {
    if (field.name === gallery.dataset.colourOption) applyColour(gallery, field.value);
  });
});
